module.exports = __webpack_public_path__ + "static/img/bus.4e183c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/bus.jpg
// module id = N5ZC
// module chunks = 1